import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';

interface UsePlaylistDetailsProps {
  playlistId: string;
}

export const usePlaylistDetails = ({ playlistId }: UsePlaylistDetailsProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();

  const playlistDetailsQuery = useTRPCQuery(
    trpcMusicAPI.playlists.details.queryOptions({ playlistId, ...shareTokenInput }, { enabled: Boolean(playlistId) })
  );

  return playlistDetailsQuery;
};
